// export const progress = (id, timestamp=new Date().toString()) => ({
//   type: 'value/progress',
//   timestamp,
//   id,
// })
export const update = (value) => ({
  type: "value/update",
  value,
});

export const create = (value) => ({
  type: "values/create",
  value,
});

export const add = (values) => ({
  type: "values/add",
  values,
});

// export const show = (id) => ({
//   type: 'value/show',
//   id,
// })

export const index = (values) => ({
  type: "values/index",
  values,
});

let nextTodoId = 0;
export const addTodo = (text) => ({
  type: "ADD_TODO",
  id: nextTodoId++,
  text,
});

export const setVisibilityFilter = (filter) => ({
  type: "SET_VISIBILITY_FILTER",
  filter,
});

export const toggleTodo = (id) => ({
  type: "TOGGLE_TODO",
  id,
});

export const VisibilityFilters = {
  SHOW_ALL: "SHOW_ALL",
  SHOW_COMPLETED: "SHOW_COMPLETED",
  SHOW_ACTIVE: "SHOW_ACTIVE",
};
